'use client'

import './popular-questions.scss'
import trackEngagementClick from '../Snowplow/lib/trackEngagementClick.client'

interface IPopularQuestionsProps {
  onSelect: (value: string) => void
  questions: string[]
}

export default function PopularQuestions({
  onSelect,
  questions,
}: IPopularQuestionsProps) {
  if (!questions?.length) return null

  return (
    <div className='popularQuestions'>
      <h3 id='popular-questions' className='popularQuestions__title'>
        Suggested:
      </h3>
      <ul className='popularQuestions__list'>
        {questions.map((question, i) => (
          <li className='popularQuestions__item' key={question + i}>
            <button
              type='button'
              data-testid='chatbot-suggestion-btn'
              className='popularQuestions__question'
              aria-describedby='popular-questions'
              onClick={() => {
                onSelect(question)
                trackEngagementClick({
                  unit_name: 'conversation',
                  unit_location: 'inline',
                  submitted_object: 'suggested_query',
                })
              }}
            >
              {question}
            </button>
          </li>
        ))}
      </ul>
    </div>
  )
}
